export const THUMBNAIL_SIZE = { width: 244, height: 180 };
